import {
    createContext,
    type PropsWithChildren,
    useMemo,
    useState,
} from 'react';

interface MobileMenuContextValue {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
}

export const MobileMenuContext = createContext<MobileMenuContextValue>({
    isOpen: false,
    setIsOpen: () => {},
});

export function MobileMenuProvider({ children }: PropsWithChildren) {
    const [isOpen, setIsOpen] = useState(false);

    const value = useMemo(
        () => ({
            isOpen,
            setIsOpen,
        }),
        [isOpen],
    );

    return (
        <MobileMenuContext.Provider value={value}>
            {children}
        </MobileMenuContext.Provider>
    );
}
